import { BehaviorSubject } from "rxjs";
import CookieStorage from "../../../utils/CookieStorage";
import { AUTH_STATE } from "../types/CommonTypes";

export const initialAuthState: AUTH_STATE = {
  isLoggedIn: false,
  userId: undefined,
  firstName: undefined,
  LastName: undefined,
  access_token: undefined,
  refresh_token: undefined,
  expires_in: undefined,
  refresh_expires_in: undefined,
  user: undefined,
  session_state: undefined,
};

const authState$ = new BehaviorSubject<AUTH_STATE>(initialAuthState);
CookieStorage.init("authState", authState$);

export default authState$;
